export class Feature {
    Name: string;
    App: string;
}
